export const PURPOSES = [
    { label: "MODEM", value: "MODEM" },
    { label: "ORDER", value: "ORDER" },
    { label: "USER", value: "USER" }
];
